import { Link } from "react-router-dom";

export default function HeroSection() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "韩漫网",
    url: "http://hongtongren.com/",
    description: "韩漫网致力于为您提供高清韩国漫画的免费在线阅读",
    potentialAction: {
      "@type": "SearchAction",
      target: "http://hongtongren.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20fantasy%20illustration%20with%20dramatic%20dynamic%20composition%2C%20warm%20golden%20and%20deep%20crimson%20color%20palette%2C%20flowing%20energy%20streaks%2C%20silhouetted%20character%20with%20sword%20in%20heroic%20pose%2C%20motion%20blur%20effects%2C%20artistic%20webtoon%20background%2C%20dark%20vignette%20edges%2C%20atmospheric%20lighting&width=1920&height=1080&seq=hero-bg-home&orientation=landscape"
            alt="韩漫网 - 高清韩国漫画免费在线阅读"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-3 md:mb-5 leading-tight"
            style={{ fontFamily: "var(--font-heading)" }}>
            韩漫大全
          </h1>
          <p className="text-lg md:text-2xl italic text-white/90 mb-2 md:mb-3"
            style={{ fontFamily: "var(--font-heading)" }}>
            高清韩国漫画
          </p>
          <p className="text-sm md:text-base text-white/70 mb-6 md:mb-8 max-w-lg mx-auto leading-relaxed">
            漫画韩漫网址，免费韩漫在线阅读 —— 韩漫网，你的韩漫世界
          </p>
          <Link
            to="/category/fantasy"
            className="inline-block px-8 md:px-10 py-3 md:py-3.5 text-sm md:text-base font-semibold bg-white text-foreground-900 rounded-full hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap"
          >
            立即开始阅读
          </Link>
        </div>
      </section>
    </>
  );
}